import React from 'react';
import { Router, Link, hashHistory } from 'react-router';

import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Avatar from 'material-ui/Avatar';
import HardwareKeyboardArrowRight from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import NavigationArrowDownward from 'material-ui/svg-icons/navigation/arrow-downward';

import Header from '../components/header.jsx';
import Navigation from '../components/navigation.jsx';
import LoadingIndicator from '../components/loadingIndicator.jsx';
import RefreshIndicator from '../components/refreshIndicator.jsx';

// TODO: filter list based off of status!!

const QuizListPage = React.createClass({
	getDefaultProps: function() {
		return {
			selectedIndex: 2,
			activeQuiz: -1
		}
	},
	getInitialState: function() {
		return {
			headerTitle: 'Quizzes',
			quizList: [],
			loading: true
		}
	},
	componentDidMount: function() {
		this._getQuizList();
		this.props.selectView(2);
	},
	_getQuizList: function() {
		let request = new XMLHttpRequest;
		request.open('GET', '/api/v2/quizzes');
		request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
		request.send(null);
		request.onreadystatechange = function() {
			if (request.readyState == 4) {
				if (request.status == 200) {
					var data = JSON.parse(request.responseText);
					data.forEach(function(quiz){
						if (quiz.status == 'in_progress') {
							quiz.status = 'in progress';
						}
					});

					this.setState({
						quizList: data,
						loading: false
					});
				} else {
					hashHistory.push("/login");
				}
			}
		}.bind(this);
	},
	_getQuizzes: function() {
		return this.state.quizList.map((quiz) => {
			return (
				<Quiz
					key={quiz._id}
					id={quiz._id}
					name={quiz.name}
					creator={quiz.creator}
					status={quiz.status}
					icon={quiz.icon}
				/>
			)
		})
	},
	render: function() {
		const style = {
			arrow: {
				fill: '#00bcd4',
			},
			refresh: {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'flex-end',
				flex: '0 0 100%',
				height: '0',
				zIndex: '90',
				overflow: 'hidden',
				backgroundColor: '#ddfcff'
			}
		};
		const quizzes = this._getQuizzes();
		if (this.state.loading) {
			return (
				<div className="view">
					<Header headerTitle={this.state.headerTitle} />
					<LoadingIndicator />
					<Navigation
						selectView={this.props.selectView}
						selectedIndex={this.props.selectedIndex}
						activeQuiz={this.props.activeQuiz}
					/>
				</div>
			)
		} else if (this.state.quizList.length) {
			return (
				<div className="view">
					<Header headerTitle={this.state.headerTitle} />
					<div className="quiz-list content">
						<RefreshIndicator
							viewClass="quiz-list"
							request={this._getQuizList.bind(this)}
						/>
						{quizzes}
					</div>
					<Navigation
						selectView={this.props.selectView}
						selectedIndex={this.props.selectedIndex}
						activeQuiz={this.props.activeQuiz}
					/>
				</div>
			)
		} else {
			return (
				<div className="view">
					<Header headerTitle={this.state.headerTitle} />
					<div className="empty content">
						<RefreshIndicator
							viewClass="quiz-list"
							request={this._getQuizList.bind(this)}
						/>
						<p>Looks like there are no quizzes!</p>
						<p>Create a quiz below to begin!</p>
					</div>
					<Navigation
						selectView={this.props.selectView}
						selectedIndex={this.props.selectedIndex}
						activeQuiz={this.props.activeQuiz}
					/>
				</div>
			)
		}
	}
});

const Quiz = React.createClass({
	getDefaultProps: function() {
		return {
			id: 0,
			name: '',
			creator: '',
			status: 'open'
		}
	},
	_openQuiz: function(id) {
		hashHistory.push('/quizzes/' + id);
	},
	render: function() {
		const style = {
			avatar: {
				height: '60px',
				width: '60px',
				marginRight: '1em',
				flex: '0 0 auto',
				borderRadius: 'none',
				backgroundColor: 'transparent',
			},
			button: {
				height: '40px',
				width: '40px',
				fill: '#888',
			}
		}

		return (
			<section className="quiz" onClick={() => this._openQuiz(this.props.id)}>
				<Avatar src={'/images/icons/' + this.props.icon + '.png'} style={style.avatar} />
				<div className="info">
					<h2>{this.props.name}</h2>
					<div>{this.props.creator}</div>
					<div className="status">{this.props.status}</div>
				</div>
				<div className="go-to">
					<HardwareKeyboardArrowRight style={style.button} />
				</div>
			</section>
		)
	}
});

export default QuizListPage;


// WEBPACK FOOTER //
// ./src/views/quiz-list.jsx